// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tab_tabs__3P34n","tabBar":"Tab_tabBar__2XIX6","button":"Tab_button__3LOuH","icon":"Tab_icon__qmsgf","badge":"Tab_badge__Jee_B","tabLabel":"Tab_tabLabel__3g23v"};